function render_GWP(){
 const gwp_form = document.querySelector('.gwp-form');
console.log(gwp_form);
  if(gwp_form) {
cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
gwp_form.addEventListener('submit', (e)=>{
  e.preventDefault();
  const variantid = gwp_form.querySelector('[name="id"]').value

  let formData = {
  'sections':['cart-icon-bubble','cart-drawer'],
  'sections_url': window.location.pathname,
 'items': [{
  'id': variantid,
  'quantity': 1,
   'properties':{
     '__type':'GWP'
   }
  }]
};
  fetch(`/cart/add.js`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then((response) => {
  return response.json();
}).then((response) => {
  cart.renderContents(response);
  console.log(response)
})
.catch((error) => {
  console.error('Error:', error);
});
})     
  }

}